module.exports = __webpack_public_path__ + "img/scroll-icon-1.736ba1ed.png";